<template>

  <div v-if="showLoad" style="position:absolute; top: 300px;   width: 100%; z-index:100;  ">
    <Circle4 size="120px" class="mx-auto"></Circle4>
  </div>

  <div class="col mb-4">
    <div class="card border-left-primary shadow h-100 p-2">
      <h5 class="text-primary font-weight-bolder">
        Хонаводаи {{ this.$store.state.household.Head }},
        {{ this.$store.state.household.Address }}
      </h5>
      <hr />

      <form>
        <div class="container-fluid">
          <div class="row">
            <button class="btn btn-primary" type="button" data-toggle="collapse" data-target="#hhpart"
              aria-expanded="true" aria-controls="hhpart">
              <i class="fas fa-fw fa-house-user"></i>
            </button>

            <div style="margin-left: 300px">
              <button class="btn btn-success mr-5" type="button" @click="add">
                <i class="fas fa-fw fa-user-plus"></i>
              </button>

              <button class="btn btn-warning" type="button" @click="first">
                <i class="fas fa-fw fa-angle-double-left"></i>
              </button>

              <button class="btn btn-outline-warning" type="button" @click="prev">
                <i class="fas fa-fw fa-angle-left"></i>
              </button>

              <button class="btn btn-outline-warning" type="button" @click="next">
                <i class="fas fa-fw fa-angle-right"></i>
              </button>
              <button class="btn btn-warning" type="button" @click="last">
                <i class="fas fa-fw fa-angle-double-right"></i>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-3" style="max-width: 300px" id="hhpart">
              <div class="card card-header shadow">
                <label for="f1" class="form-label">Суратҳисоб </label>
                <div class="input-group mb-3">
                  <input type="text" id="f1" class="form-control"    @change="markModified(hh)"
                    v-model="this.$store.state.household.Account" />
                </div>

                <label for="f2" class="form-label">Ному насаби сардор</label>
                <div class="input-group mb-3">
                  <input type="text" id="f2"  class="form-control" placeholder=" " aria-label="Server"  @change="markModified(hh)"
                    v-model="this.$store.state.household.Head" />
                </div>

                <label for="f3" class="form-label">Суроға </label>
                <div class="input-group mb-3">
                  <input type="text"  id="f3" class="form-control" placeholder=" " aria-label="Server"  @change="markModified(hh)"
                    v-model="this.$store.state.household.Address" />
                </div>

                <label for="f4" class="form-label">Китоб </label>
                <div class="input-group mb-3">
                  <input type="text"  id="f4" class="form-control" placeholder=" " aria-label="Server"  @change="markModified(hh)"
                    v-model="this.$store.state.household.Nbook" />
                </div>

                <label for="f5" class="form-label">Саҳифа </label>
                <div class="input-group mb-3">
                  <input type="text"  id="f5" class="form-control" placeholder=" " aria-label="Server"  @change="markModified(hh)"
                    v-model="this.$store.state.household.Npage" />
                </div>

                <label for="f6" class="form-label">Телефон </label>
                <div class="input-group mb-3">
                  <input type="text"  id="f6" class="form-control" placeholder=" " aria-label="Server"  @change="markModified(hh)"
                    v-model="this.$store.state.household.Phone" />
                </div>


                <label for="f7" class="form-label">Намуди хоҷагӣ </label>
                <div class="input-group mb-3">
                  <select class="form-control"  id="f7" v-model="this.$store.state.household.Category"  @change="markModified(hh)">
                    <option value="1">Хоҷагии деҳқонон</option>
                    <option value="2">
                      Хоҷагиҳои коргарон ва хизматчиҳо (хоҷагиҳои кормандони
                      муассисаҳо ва ташкилотҳои ҳамаи шаклҳои моликият, ғайр аз
                      хоҷагиҳои ҷамоавӣ (кооперативҳо) ва хоҷагиҳои деҳқонӣ)
                    </option>
                    <option value="3">
                      Хоҷагии шахсоне, ки ба фаъолияти инфиродии меҳнатӣ
                      машғуланд
                    </option>
                    <option value="4">
                      Дигар гурӯҳи хоҷагиҳои аҳолӣ (хизматчиёни муассисаҳои
                      динӣ, руҳониён ва ғайра)
                    </option>
                  </select>
                </div>

                <!-- <div class="input-group mb-3">
                  <input type="checkbox" class="form-control" placeholder=" " aria-label="Server"  @change="markModified(hh)"
                    v-model="this.$store.state.household.Typ" />
                </div> -->

                <div class="form-group text-center mt-5">
                  <input type="button" value="Сабткунӣ" v-if="!this.hideSave" class="btn btn-primary"  
                    :disabled="dissave" @click="save" />

                  <input type="button" value="Отмена" v-if="!this.hideCancel" class="btn btn-danger ml-2"  
                    :disabled="discancel" @click="cancel" />

                  <button class="btn btn-warning" v-if="!this.hideClose" @click="this.$emit('close')">
                    Махкамкунӣ
                  </button>
                </div>
              </div>
            </div>

            <div class="col-9">


              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" id="home-tab" data-toggle="tab" href="#part1" role="tab"
                    aria-controls="home" aria-selected="true">Қисми 1</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="profile-tab" data-toggle="tab" href="#part2" role="tab"
                    aria-controls="profile" aria-selected="false">Қисми 2</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#part3" role="tab"
                    aria-controls="contact" aria-selected="false">Қисми 3</a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#part4" role="tab"
                    aria-controls="contact" aria-selected="false">Қисми 4</a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#part5" role="tab"
                    aria-controls="contact" aria-selected="false">Қисми 5</a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#part6" role="tab"
                    aria-controls="contact" aria-selected="false">Қисми 6</a>
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="part1" role="tabpanel" aria-labelledby="home-tab">



                  <div class="pl-1" ref="div" style="overflow-x: auto">
                    <div class="scrolling-wrapper row d-flex flex-row flex-nowrap pb-4">
                      <div style="min-width: 250px">
                        <div class="card row border-primary m-2">
                          <div class="card-header text-center">&nbsp;</div>
                          <div class="card-body">
                            <div class="input-group mb-3">
                              <span class="form-control"> Ном </span>
                            </div>
                            <div class="input-group mb-3">
                              <span class="form-control"> Насаб </span>
                            </div>
                            <div class="input-group mb-3">
                              <span class="form-control"> Номи падар </span>
                            </div>
                            <div class="input-group mb-3">
                              <span class="form-control"> ИНН </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Муносибат </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Ҷинс </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Соли таваллуд </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Миллат </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Маълумотнокӣ </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Таҳсил </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Номи муассиса </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Суроға </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Синф ё курс </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Ҷои кор </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Вазифа </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control">
                                Санаи муваққатан рафтан
                              </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Сабаб </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control">
                                Санаи муваққатан омадан
                              </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control">
                                Санаи тамоман рафтан
                              </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Сабаб </span>
                            </div>
                            <div class="input-group mb-3">
                              <span class="form-control"> Санаи нав омадан </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> аз куҷо омадан </span>
                            </div>
                            <div class="input-group mb-3">
                              <span class="form-control"> Намуди нафақахӯрӣ </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Телефон </span>
                            </div>

                            <div class="input-group mb-3">
                              <span class="form-control"> Эзоҳ </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-3" v-for="(m, index) in this.$store.state.members" :key="index"
                        :ref="'div_' + index">
                        <div class="card m-2" :class="{ 'bg-delete border-danger': m.Idhh === -999 }">
                          <div class="card-header text-center">
                            {{ index + 1 }}
                            <!--
                        <div class="btn-group">
                          <button
                            class="nav-link dropdown-toggle dropdown-toggle"
                            type="button"
                            :id="'dropdownMenuButton_' + index"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="fas fa-fw fa-ellipsis-v"></i>
                          </button>

                          <ul
                            class="dropdown-menu"
                            :aria-labelledby="'dropdownMenuButton_' + index"
                          >
                            <li>
                              <a class="dropdown-item" href="#">Тозакунӣ</a>
                            </li>
                            <li>
                              <a class="dropdown-item" href="#"
                                >Ҳамроҳкунӣ ба рӯйхати маъюбон</a
                              >
                            </li>
                            <li>
                              <a class="dropdown-item" href="#"
                                >Хориҷкунӣ аз рӯйхати маъюбон</a
                              >
                            </li>
                          </ul>
                        </div>
-->
                          </div>
                          <div class="card-body">
                            <div class="input-group mb-3">
                              <input v-model="m.Name" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Surname" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Midname" class="form-control"  @change="markModified(m)"/>
                            </div>

                            <div class="input-group mb-3">
                              <input v-model="m.INN" Class="form-control "  @change="markModified(m)"/>

         
                            </div>
                            <div class="input-group mb-3">
                              <select v-model="m.Rel" class="form-control"  @change="markModified(m)">
                                <option value="1">Сардори хоҷагӣ</option>
                                <option value="2">зан / шавҳар</option>
                                <option value="3">писар / духтар</option>
                                <option value="4">падар / модар</option>
                                <option value="5">келин / домод</option>
                                <option value="6">набера</option>
                                <option value="7">бародар / хоҳар</option>
                                <option value="8">дигар хешовандон</option>
                                <option value="9">хеш не</option>
                              </select>
                            </div>
                            <div class="input-group mb-3">
                              <select v-model="m.Sex" class="form-control"  @change="markModified(m)">
                                <option value="1">Мард</option>
                                <option value="2">Зан</option>
                              </select>
                            </div>
                            <div class="input-group mb-3">
                              <input style="width: 550px;" type="date" v-model="m.Birthday" class="form-control"  @change="markModified(m)"/>

                            </div>

                            <div class="input-group mb-3">
                              <select v-model="m.Nation" class="form-control" @change="markModified(m)">
                                <option value="0"></option>
                                <option value="1">тоҷик</option>
                                <option value="2">ӯзбек</option>
                                <option value="3">қирғиз</option>
                                <option value="4">қазоқ</option>
                                <option value="5">татар</option>
                                <option value="6">рус</option>
                                <option value="7">туркман</option>
                                <option value="8">дигар</option>
                              </select>
                            </div>

                            <div class="input-group mb-3">
                              <select v-model="m.Educ" class="form-control" @change="markModified(m)">
                                <option value="null"></option>
                                <option value="1">
                                  олии касбӣ (донишгоҳҳо ва донишкадаҳо)
                                </option>
                                <option value="2">олии нопурра</option>
                                <option value="3">
                                  миёнаи касбӣ (техникум ва коллеҷҳо)
                                </option>
                                <option value="4">ибтидоии касбӣ ОКТ</option>
                                <option value="5">миёнаи (пурраи) умумӣ</option>
                                <option value="6">
                                  миёнаи нопурраи умумӣ (асосӣ)
                                </option>
                                <option value="7">ибтидоӣ</option>
                                <option value="8">маълумоти ибтидоӣ надорад</option>
                                <option value="9">
                                  бесавод (хонда ва навишта наметавонад)
                                </option>
                              </select>
                            </div>
                            <div class="input-group mb-3">
                              <select v-model="m.Studytype" class="form-control"  @change="markModified(m)">
                                <option value="null"></option>
                                <option value="1">Мактаб</option>
                                <option value="2">Коллеҷ</option>
                                <option value="3">Донишгоҳ</option>
                              </select>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Studyname" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Studyaddress" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Studyclass" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Job" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Position" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input type="date" v-model="m.Departdata" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Depart" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input type="date" v-model="m.Arrivedata" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input type="date" v-model="m.Leavingdata" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Leaving" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input type="date" v-model="m.Comingdata" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Coming" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <select v-model="m.Pensiontype" class="form-control"  @change="markModified(m)">
                                <option value="0"></option>
                                <option value="1">Пиронсолӣ</option>
                                <option value="2">Маъюби гурӯҳи 1</option>
                                <option value="3">Маъюби гурӯҳи 2</option>
                                <option value="4">Маъюби гурӯҳи 3</option>
                                <option value="5">Иҷтимоӣ</option>
                                <option value="6">Кӯмакпулӣ</option>
                              </select>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Phone" class="form-control"  @change="markModified(m)"/>
                            </div>
                            <div class="input-group mb-3">
                              <input v-model="m.Comment" class="form-control"  @change="markModified(m)"/>
                            </div>

                            <div class="input-group mb-3">
                              <button class="btn btn-danger mx-auto" @click="del(index)">
                                <i class="fas fa-fw fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <part :class2="this.class2">

                </part>

              </div>


            </div>
          </div>
        </div>
      </form>
    </div>
  </div>



  <modal v-if="isModalVisible" @close="closeModal">

    <template v-slot:header>
      <h3 class="text-danger">Иштибоҳ!</h3>
    </template>

    <template v-slot:body>
      {{ errormsg }}
    </template>

  </modal>

  <modal v-if="isModalVisible2" @close="closeModal2">

    <template v-slot:header>
      <h3 class="text-success">Сабткунӣ!</h3>
    </template>

    <template v-slot:body>
      {{ msg }}
    </template>

  </modal>



</template>

<script>

import modal from "./Modal2"
import part from "./Parts"
import func from "./func/func"

export default {
  name: "Members2",
  props: ["id"],
  components: { modal, part },

  data() {
    return {
      class2: [],
      hideClose: true,
      hideSave: false,
      hideCancel: false,
      showLoad: false,
      errormsg: '',
      msg: '',
      isModalVisible: false,
      isModalVisible2: false,
      dissave: false,
      discancel: false,
      hh:this.$store.state.household
      //household:{},members:[]
    };
  },
  methods: {
    ...func,
    showModal(t) {
      this.isModalVisible = true;
      this.errormsg = t;
    },
    showModal2(t) {
      this.isModalVisible2 = true;
      this.msg = t;
    },

    closeModal() {
      this.isModalVisible = false;
    },
    closeModal2() {
      this.isModalVisible2 = false;
    },

    async save() {
      this.dissave = true;
// console.log('rule',this.$store.state.household._state==1 ||  this.$store.state.members.filter(m => m._state >0) || this.$store.state.data.filter(m => m._state >0))

         if( !(this.$store.state.household._state==1 ||  this.$store.state.members.filter(m => m._state >0 || m.Idhh==-999).length>0 || this.class2.filter(m => m._state >0).length>0))
         {
            this.showModal("Маълуоти барои сабт мавҷуд нест");
            this.dissave = false;
            return;
            
         }

      // prepare data for save


      this.showLoad = true;

      console.log(this.class2)
      console.log(this.class2.filter(m => m._state >0))

      this.class2.forEach(el => {
        var flag = false;
        this.$store.state.data.forEach(el2 => {

          //el.c01=1;
          if (el2.IdClass === el.ID) {
            //console.log('el.c01',el2.c01,el.c01,el.c01==''?null:el.c01)


            // console.log('compare rez true',el2.IdClass,el.ID,el2.IdClass==el.ID,el.c01);
            el2.c01 = el.c01 ;
            el2.c02 = el.c02 ;
            el2.c03 = el.c03 ;
            el2.c04 = el.c04 ;
    if (el._state==1)
            el2._state=1;

            flag = true;
          }
        });


        if (!flag) {
          if (el.c01 > 0 || el.c02 > 0 || el.c03 > 0 || el.c04 > 0)


            this.$store.state.data.push(
              {
                Idhh: this.id,
                IdClass: el.ID,
                c01: el.c01,
                c02: el.c02,
                c03: el.c03,
                c04: el.c04,
                _state: 1

              }
            );

        }



      });

// console.log(this.$store.state.data)
// console.log(this.$store.state.data.filter(m => m._state >0))
// console.log(this.$store.state.data.filter(m => m._state ==1))

       console.log(
         "body",
         {
           ID: 0,
          hh: this.$store.state.household._state==1?this.$store.state.household:{},
           mem: this.$store.state.members.filter(m => m._state >0 || m.Idhh==-999),
          dat: this.$store.state.data.filter(m => m._state >0),
           terid: this.$store.state.terid,
          iduser: this.$store.state.iduser
        }
       );

      await this.$api( "/api/data/1/", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          hh: this.$store.state.household._state==1?this.$store.state.household:{},
          mem: this.$store.state.members.filter(m => m._state >0 || m.Idhh==-999),
          dat: this.$store.state.data.filter(m => m._state >0),
          terid: this.$store.state.terid,
          iduser: this.$store.state.iduser
        }),
      })
     //   .then((response) => response.json())
        .then((data) => {
          console.log("ret", data, data == 1);
          if (data == 1) {
            // console.log("go -1 ");
            // this.$router.go(-1);

            //               var path = window.location.hash.split('?')[0].replace('#', '');

            // console.log(path);

            //    if(path=='/Members')
            //   {
            //     console.log("go --1 ");
            //     this.$router.go(-1);
            //   }


            this.hideClose = false;

            this.hideCancel = true;
            this.hideSave = true;

            this.dissave = true;
            this.discancel = true;

            this.showModal2("Маълумот бо муваффақият сабт шуд");

          }
          else {
            console.log("error", data.title);
            this.showModal(data.title);

          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
          this.showModal(error);
        });

      this.dissave = false;
      this.showLoad = false;

      //console.log("go prev")
      //    this.$router.go(-1);
    },

    onScroll(){},

    cancel() {
      // this.$router.go(-1);
      this.$emit('close')
    },

    add() {
      this.$store.state.members.push({
        ID: 0,
        idhh: this.id,
      });
    },

    del(i) {
      // console.log(i);
      // console.log(this.$store.state.members[i].ID);

      // console.log(this.$store.state.members[i].Idhh);



      if (this.$store.state.members[i].ID == 0)
        this.$store.state.members.splice(i, 1);

      else this.$store.state.members[i].Idhh = -999;


      // console.log(this.$store.state.members[i].Idhh);
    },

    set(f) {
      console.log('mem count', f.Members.length)
      console.log('data count', f.Datas.length)


      this.$store.state.data = f.Datas
      this.$store.state.members = f.Members

      console.log('class', this.$store.state.class);
      // combine

      this.class2 = JSON.parse(JSON.stringify(this.$store.state.class));

      this.$store.state.data.forEach(element => {

        this.class2.forEach(el => {
          //console.log('compare rez true',element.IdClass,el.ID,element.IdClass==el.ID,el.c01);
          //el.c01=1;
          if (element.IdClass === el.ID) {
            //  console.log('compare rez true',element.IdClass,el.ID,element.IdClass==el.ID,el.c01);
            el.c01 = element.c01;
            el.c02 = element.c02;
            el.c03 = element.c03;
            el.c04 = element.c04;
          }
        });



      });

    },
    first() {
      const el = this.$refs.div;
      // el.scrollLeft = 0;
      el.scrollTo({ left: 0, behavior: 'smooth' })
    },
    prev() {
      const el = this.$refs.div;
      //el.scrollLeft -= 300;
      el.scrollBy({ left: -300, behavior: 'smooth' })
    },
    next() {
      const el = this.$refs.div;

      //  el.scrollLeft+=300;
      el.scrollBy({ left: +300, behavior: 'smooth' })

    },

    last() {
      const el = this.$refs.div;
      // el.scrollLeft = 10000000;
      el.scrollTo({ left: el.scrollWidth, behavior: 'smooth' })
    },
    markModified(row) {
  //  if (row._state || row._state !=1) {
        row._state = 1
        console.log(row);
  //  }
},
    async fetchMembers() {


      this.dissave = true;


      console.log("start2", this.id);

      this.$store.state.members = '';
      console.log('before fetch', this.$store.state.members);
      await this.$api(
         "/api/data/3/" + this.id
      )
       // .then((res) => res.json())
        .then((data) => (this.set(data)))
        //.then((data) => (this.$store.state.data = data.Datas))
        .catch((error) => {
          console.error("There was an error!", error);
        });

      console.log("after fetch members", this.$store.state.members);
      console.log("after fetch data", this.$store.state.data);

      for (let index = 0; index < this.$store.state.members.length; index++) {
        const el = this.$store.state.members[index];
        el.Birthday = el.Birthday.substring(0, 10);

        if (typeof el.Departdata === "string") el.Departdata = el.Departdata.substring(0, 10);
        if (typeof el.Arrivedata === "string") el.Arrivedata = el.Arrivedata.substring(0, 10);
        if (typeof el.Leavingdata === "string") el.Leavingdata = el.Leavingdata.substring(0, 10);
        if (typeof el.Comingdata === "string") el.Comingdata = el.Comingdata.substring(0, 10);
      }
      console.log("stop2");
      console.log("members", this.$store.state.members);

      this.dissave = false;

    },
  },

  mounted() {
    console.log("Mount member", this.id);
    if (this.id > 0) {
      console.log("Object", this.id);
      this.fetchMembers();


  // const tab = document.querySelector('#myTab a[href="#part3"]'))
  // tab.show()
    }

    //this.showModal();
  },

  unmounted() {

    this.$store.state.data = [];
    this.$store.state.members = [];
    this.class2 = [];
    console.log("unmounted members", this.$store.state.members);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-delete {
  background-color: rgb(240, 169, 169);
}
</style>
